import { useRef, type FocusEvent } from 'react'

/**
 * Devolve ao próximo campo o foco que o `FocusScope` do Radix desvia para a
 * caixa do diálogo.
 */
export function useFocoDoTab() {
    /** Para onde o Tab estava levando o foco. */
    const destinoRef = useRef<HTMLElement | null>(null)

    return {
        onBlur: (evento: FocusEvent<HTMLElement>) => {
            const proximo = evento.relatedTarget as HTMLElement | null
            destinoRef.current =
                proximo && evento.currentTarget.contains(proximo)
                    ? proximo
                    : null
        },
        onFocus: (evento: FocusEvent<HTMLElement>) => {
            const pretendido = destinoRef.current
            destinoRef.current = null
            // Foco em qualquer outro lugar do diálogo é o Tab funcionando.
            if (evento.target !== evento.currentTarget) return
            if (pretendido?.isConnected) pretendido.focus()
        },
    }
}
